import React from 'react';
import api from 'services';
import { showNotification } from 'helpers';

import CircularProgress from 'material-ui/CircularProgress';
import Pagination from 'components/Libs/Pagination';

import PdaTable from './PdaTable';
import PdaFilters from './PdaFilters';

import { getCountries } from 'actions/countries';
import styles from 'styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const vesselTypes = [
    'bulk', 'mpp', 'cont', 'car', 'reefer', 'tank', 'passcar',
];

const initialFilter = {
    vessel: { _id: '', name: '', imoNumber: '' },
    vesselType: '',
    port: { _id: '', name: '' },
    country: { _id: '', name: '' },
    dwtMin: null,
    dwtMax: null,
    confirmed: true,
};

const pagination = {
    page: 1,
    limit: 25,
};

class Pda extends React.Component {
    constructor(props) {
        super(props);

        
    
        this.state = {
            isLoaded: false,
            rowsPerPage: [10, 25, 50, 100],
            total: 0,
            pagination,
            pdas: [],
            countries: [],
            filter: Object.assign({}, initialFilter),
            openAddDialog: false,
        };
    }

    async UNSAFE_componentWillMount() {
        let { pagination: { page, limit }, filter } = this.state;

        this.props.getCountries();

        let res = await this.getPdaData({ page, limit, filter });
        if(res.status === 200) {
            let { total, pdas } = res.data;
            this.setState({
                pdas,
                total,
                isLoaded: true
            })
            showNotification('PDA loaded', 'success');
        } else {
            showNotification(res.errors[0].messages[0], 'error');
        }
    }

    async getPdaData(data) {
        return await api.pdaGetAll(data);
    }

    handleChangePagination = async ({ page, numberOfRows }) => {
        this.setState({
            pagination: {
                page,
                limit: numberOfRows,
            },
        }, async () => {
            await this.handleFilter();
        });
    }

    modifyFilter = (field, data, cb) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: data,
            },
        }, cb);
    }

    handleFilter = async () => {
        let reqObj = {
            ...this.state.pagination,
            filter: this.state.filter,
        };
        let res = await this.getPdaData(reqObj);

        if(res.status === 200) {
            let { total, pdas } = res.data;
            this.setState({
                ...this.state,
                pdas,
                total,
            })
            showNotification('PDA loaded', 'success');
        } else {
            showNotification(res.errors[0].messages[0], 'error');
        }
    }


    handleModifyPdaState = async (index, field = undefined, data) => {
        if(field) {
            this.setState(({ pdas }) => ({
                pdas: [
                    ...pdas.slice(0, index - 1),
                    {
                        ...pdas[index],
                        [field]: data,
                    },
                    ...pdas.slice(index + 1),
                ],
            }));
        }
    }

    handleOpenAddDialog = () => {
        this.setState({
            openAddDialog: !this.state.openAddDialog,
        });
    }

    handleReset = () => {
        this.setState({
            filter: {
                ...Object.assign({}, initialFilter),
            },
            pagination,
        }, async () => {
            await this.handleFilter();
        })
    }

    render() {
        const { 
            total, 
            rowsPerPage, 
            pagination: { page, limit }, 
            filter, 
            pdas,
            openAddDialog,
        } = this.state;
        
        const { countries } = this.props;
        
        let renderPagination = (<Pagination
            total={total}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={limit}
            updateRows={this.handleChangePagination}
        />);

        return (
            <div className='table-page'>
                <div className='container'>
                    <h2>Pda</h2>
                    <div className='table-header'>
                        <div className='item'></div>
                        <div className='item'>
                            {renderPagination}
                        </div>
                    </div>
                    <PdaFilters
                        filter={filter}
                        modifyFilter={this.modifyFilter}
                        handleFilter={this.handleFilter}
                        handleOpenAddDialog={this.handleOpenAddDialog}
                        vesselTypes={vesselTypes}
                        handleReset={this.handleReset}
                    />

                    <CircularProgress
                        className={!this.state.isLoaded ? '' : 'hidden'}
                        style={styles.circularProgress}
                    />
                    <div className={this.state.isLoaded ? 'table-body' : 'table-body hidden'}>
                        <PdaTable 
                            pdas={pdas}
                            handleModifyPdaState={this.handleModifyPdaState}
                            handleOpenAddDialog={this.handleOpenAddDialog}
                            handleFilter={this.handleFilter}
                            countries={countries}
                            openAddDialog={openAddDialog}
                            vesselTypes={vesselTypes}
                            shouldShowConfirmCheckbox={!filter.confirmed}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        return {
            countries: state.countries.items,
        };
    },
    dispatch => bindActionCreators({
        getCountries,
    },
    dispatch),
)(Pda);



// WEBPACK FOOTER //
// ./app/components/Prices/Pda/Pda.jsx